import * as types from '../mutation-types'

export default {
	namespaced: true,
	state: {
		categories: [],
		hierarchyCategories: []
	},

	actions: {
		fetchAll({ commit }) {
			return axios.get('/categories').then(({ data }) => {
				commit(types.STORE_CATEGORIES, data.filter(c => !c.deletedAt));
				return data.filter(c => !c.deletedAt);
			})
		},
		fetchAllAsHierarchy({ commit }) {
			return axios.get('/categories/hierarchy').then(({ data }) => {
				commit(types.STORE_HIERARCHY_CATEGORIES, data);
				return data;
			})
		},
		fetchBySlug({ commit }, { slug }) {
			return axios.get(`/categories/view/${slug}`).then(({ data }) => data)
		},

		create({ commit }, { name, summary, description, setIds, categoryId, attributes, descriptionSeo, keywordsSeo, image }) {
			const formData = new FormData();
			const requestData = { name, summary, description, categoryId, descriptionSeo, keywordsSeo, image };
			Object.keys(requestData).forEach(key => {
				if (requestData[key]) {
					formData.append(key, requestData[key]);
				}
			})
			setIds.forEach(id => {
				formData.append('setIds[]', id);
			});
			if (attributes) {
				attributes.forEach(attribute => {
					formData.append('attributes[]', attribute);
				});
			}

			return axios.post('/categories', formData);
		},

		update({ commit }, { id, name, summary, description, setIds, categoryId, attributes, descriptionSeo, keywordsSeo, image }) {
			const formData = new FormData();
			const requestData = { name, summary, description, categoryId, descriptionSeo, keywordsSeo, image };
			Object.keys(requestData).forEach(key => {
				if (requestData[key]) {
					formData.append(key, requestData[key]);
				}
			})
			setIds.forEach(id => {
				formData.append('setIds[]', id);
			});
			if (attributes) {
				attributes.forEach(attribute => {
					formData.append('attributes[]', attribute);
				});
			}
			formData.append('_method', 'PUT');
			return axios.post(`/categories/${id}`, formData);
		},

		delete({ commit }, { id }) {
			return axios.delete(`/categories/${id}`)
		},
		restore({ commit }, { id }) {
			return axios.patch(`/categories/${id}`)
		},
	},

	mutations: {
		[types.STORE_CATEGORIES](state, categories) {
			state.categories = categories;
		},
		[types.STORE_HIERARCHY_CATEGORIES](state, hierarchyCategories) {
			state.hierarchyCategories = hierarchyCategories;
		}
	},

	getters: {
		getCategoryById: state => id => state.categories.find(c => c.id === id),
		getCategoryBySlug: state => slug => state.categories.find(c => c.slug === slug),
	}
}